import { inject } from '@angular/core';
import { CanMatchFn, Routes } from '@angular/router';

import { AuthService } from './core/auth-store';
import { isMobileDevice, isTabletDevice } from './core/guards/device.guard';
import { ShellComponent } from './shell/shell.component';

const signedOutUser: CanMatchFn = () => {
  const auth = inject(AuthService);

  return auth.signedOutCheck();
};

const signedInUser: CanMatchFn = () => {
  const auth = inject(AuthService);

  return auth.signedInCheck();
};

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    title: 'Sign In',
    loadChildren: () =>
      import('./auth/signin/signin.routes').then((m) => m.signinRoutes),
    canMatch: [signedOutUser],
  },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: 'dashboard',
        pathMatch: 'full',
        title: 'Dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (m) => m.dashboardRoutes,
          ),
        canMatch: [isTabletDevice],
      },
      {
        path: 'mobile',
        loadChildren: () =>
          import('./pages/mobile/mobile.routes').then((m) => m.mobileRoutes),
        canMatch: [isMobileDevice],
      },
    ],
    canMatch: [signedInUser],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
